export default __webpack_public_path__ + "static/media/Two-Moons-Nate-Baldwin.192edcd2.jpg";